import firebase from 'firebase';
import _ from 'lodash';

import View from '../_components/view/view.js';
import homeSectionTpl from './home-section.tpl.html';
import './home-section.styles.less';

import utils from '../_utils/utils.js';
import appEvts from '../_services/app-events.service.js';
import playersService from '../_services/players.service.js';
import groupsService from '../_services/groups.service.js';
import matchesService from '../_services/matches.service.js';
import CompleteGroupView from '../_components/complete-group/complete-group.view.js';

class HomeSectionView extends View {

	constructor (data, options) {
		let viewOptions = {
			viewClass: 'home-section'
		};

		super(homeSectionTpl, data, _.extend(options, viewOptions));
	}

	uiElements() {
		return _.extend(super.uiElements(), {
			roundContainer: '.round-container',
			loaderContainer: '.loader-container',
			noActiveRoundMsg: '.no-active-round-message',
			roundDates: '.round-dates',
			startDate: '.start-date',
			endDate: '.end-date',
			currentDate: '.current-date',
			lastNewBox: '.last-new-box',
			viewMoreNews: '.view-more-news'
		});
	}

	render(data) {
		super.render(data);
	}

	initializeEvents() {
		//UI Events
		this.ui.viewMoreNews.click(() => {
			window.history.pushState('news', 'news', '/?section=news');
			appEvts.trigger('goto:section:news')
		});

		///Database Events
		firebase.database().ref('/currentRound/isActive')
			.on('value', __roundActive => {
				this.isRoundActive = __roundActive.val();
			});
		firebase.auth().onAuthStateChanged( user => {
			this.user = user;
			this.updateView();
		});

		firebase.database().ref('/matches').on('value', __matches => {
			this.__matches = __matches;
			this.updateView();
		});
		firebase.database().ref('/groups').on('value', __groups => {
			this.__groups = __groups;
			this.updateView();
		});
		firebase.database().ref('/players').once('value', __players => {
			this.__players = __players;
			this.updateView();
		});
		firebase.database().ref('/currentRound').on('value', __currentRound => {
			this.currentRoundData = __currentRound.val();
			this.updateView();
		});

		firebase.database().ref('/news').limitToLast(1).on('value', __news => {
			this.lastNew = _.toArray(__news.val())[0];
			this.updateLastNewBox();
		});
			
	}

	updateView() {
		if (this.__matches && this.__groups && this.__players && this.currentRoundData) {
			if (this.isRoundActive === false) {
				this.ui.roundDates.addClass('hidden');
				this.ui.noActiveRoundMsg.removeClass('hidden');
				this.ui.loaderContainer.addClass('hidden');
				this.ui.roundContainer.addClass('hidden');
			} else {
				this.ui.roundContainer.empty();

				this.setDates();

				this.__groups.forEach(__group => {
					let
					groupPlayers = _.pickBy(this.__players.val(), player => player.groupId === __group.key);
					
					if (Object.keys(groupPlayers).length > 0) {
						let
						groupPlayersArray = _.filter(
							playersService.toArrayWithIds(this.__players), 
							player => player.groupId === __group.key
						),
						groupMatches = _.filter(
							matchesService.toArrayWithIds(this.__matches), 
							match => match.groupId === __group.key
						),
						groupStandings  = groupsService.getGroupStandings(groupMatches, groupPlayersArray),

						completeGroupView = new CompleteGroupView(
							{
								players: groupPlayers,
								group: __group.val(),
								groupMatches: groupMatches,
								groupStandings: groupStandings,
								user: this.user
							}, {
								__group: this.__group,
								__matches: this.__matches,
								__players: this.__players
							}
						).appendTo(this.ui.roundContainer);
					}
				});

				this.ui.roundDates.removeClass('hidden');
				this.ui.roundContainer.removeClass('hidden');
				this.ui.noActiveRoundMsg.addClass('hidden');
				this.ui.loaderContainer.addClass('hidden');
			}
		}
	}

	setDates() {
		let 
		startDate = utils.parseDate(this.currentRoundData.startDate),
		endDate = utils.parseDate(this.currentRoundData.endDate, '23:59:59'),
		currentDate = Date.now(),

		roundTotalTime = endDate.getTime() - startDate.getTime(),
		roundElapsedTime = currentDate - startDate.getTime(),

		roundElapsedPercentage = (100 / roundTotalTime) * roundElapsedTime;

		this.ui.startDate.text(
			this.currentRoundData.startDate
		);
		this.ui.endDate.text(
			this.currentRoundData.endDate
		);
		this.ui.currentDate.css('width', (100 - roundElapsedPercentage) + '%');
	}

	updateLastNewBox() {
		if (this.lastNew) {
			this.ui.lastNewBox.find('.item-title').text(this.lastNew.title);
			this.ui.lastNewBox.find('.item-text').html(
				_.escape(this.lastNew.text).replace(/\n/g, '<br />')
			);
			//this.ui.lastNewBox.find('item-date').text(this.lastNew.created);
			this.ui.lastNewBox.removeClass('hidden');
		} else {
			this.ui.lastNewBox.addClass('hidden');
		}
	}

}

export default HomeSectionView;


// WEBPACK FOOTER //
// ./C:/Users/juanb/Dev/transforma-ping-pong-league/src/home-section/home-section.view.js